import React, { useState } from 'react';
import { Modal, Button, Form, Alert, InputGroup, Row, Col, Badge, Card } from 'react-bootstrap';

export default function StepForm({ step, onClose, onSave }) {
  // Guard against null step
  if (!step) {
    console.warn('StepForm received null step, rendering nothing');
    return null; // Return null if step is null
  }

  const [form, setForm] = useState({ ...step });
  const [error, setError] = useState('');

  const handleSave = (e) => {
    if (e) e.stopPropagation();
    console.log('Save button clicked, form:', form); // Debug log
    if (!form.description.en.trim() || !form.description.fr.trim()) {
      setError('Both English and French descriptions are required.');
      return;
    }
    setError('');
    onSave(form);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      handleSave(e);
    }
  };

  const getConnectionsCount = () => {
    return form.options ? Object.keys(form.options).length : 0;
  };

  const handleButtonClick = (handler) => (e) => {
    e.stopPropagation();
    handler(e);
  };

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(15, 23, 42, 0.75)',
        backdropFilter: 'blur(8px)',
        zIndex: 1050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        pointerEvents: 'none', // Allows clicks to pass through to modal
      }}
      onClick={onClose} // Close on backdrop click
    >
      <div 
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          width: '100%',
          maxWidth: '900px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          overflow: 'hidden',
          border: '1px solid rgba(148, 163, 184, 0.1)',
          pointerEvents: 'auto', // Enables clicks on modal content
        }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        {/* Header Section */}
        <div style={{
          background: 'linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%)',
          padding: '2rem 2.5rem 1.5rem',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '200px',
            height: '200px',
            background: 'radial-gradient(circle, rgba(168, 85, 247, 0.1) 0%, transparent 70%)',
            borderRadius: '50%',
            transform: 'translate(50%, -50%)'
          }}></div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'relative',
            zIndex: 2
          }}>
            <div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '0.5rem'
              }}>
                <h2 style={{
                  color: '#ffffff',
                  fontSize: '1.875rem',
                  fontWeight: '700',
                  margin: '0 1rem 0 0',
                  letterSpacing: '-0.025em'
                }}>
                  Edit Step
                </h2>
                {getConnectionsCount() > 0 && (
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.15)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: '8px',
                    padding: '0.375rem 0.75rem',
                    backdropFilter: 'blur(10px)'
                  }}>
                    <span style={{
                      color: 'rgba(255, 255, 255, 0.9)',
                      fontSize: '0.875rem',
                      fontWeight: '500'
                    }}>
                      {getConnectionsCount()} connections
                    </span>
                  </div>
                )}
              </div>
              <p style={{
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: '1rem',
                margin: 0,
                fontWeight: '400'
              }}>
                Modify the content and settings for this workflow step
              </p>
            </div>
            <button
              type="button"
              onClick={handleButtonClick(onClose)}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: 'white',
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                fontSize: '1.25rem',
                transition: 'all 0.2s ease',
                backdropFilter: 'blur(10px)'
              }}
              onMouseEnter={e => {
                e.target.style.background = 'rgba(239, 68, 68, 0.2)';
                e.target.style.borderColor = 'rgba(239, 68, 68, 0.3)';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={e => {
                e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                e.target.style.transform = 'scale(1)';
              }}
            >
              ×
            </button>
          </div>
          <div style={{
            marginTop: '1rem',
            display: 'inline-block',
            background: 'rgba(0, 0, 0, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '6px',
            padding: '0.25rem 0.5rem',
            backdropFilter: 'blur(10px)'
          }}>
            <span style={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '0.75rem',
              fontWeight: '500'
            }}>
              ID: {step._id?.slice(-8) || 'Unknown'}
            </span>
          </div>
        </div>

        {/* Content Section */}
        <div style={{
          padding: '2.5rem',
          background: '#fafbfc'
        }}>
          {error && (
            <div style={{
              background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
              border: '1px solid #fca5a5',
              borderRadius: '12px',
              padding: '1rem 1.25rem',
              marginBottom: '2rem',
              display: 'flex',
              alignItems: 'center'
            }}>
              <div style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                background: '#ef4444',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '0.75rem',
                flexShrink: 0
              }}>
                <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>!</span>
              </div>
              <span style={{ color: '#dc2626', fontWeight: '500' }}>{error}</span>
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
            <div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '1rem'
              }}>
                <div style={{
                  width: '28px',
                  height: '20px',
                  background: 'linear-gradient(to bottom, #012169 33%, #fff 33%, #fff 66%, #c8102e 66%)',
                  borderRadius: '4px',
                  marginRight: '0.75rem',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}></div>
                <label style={{
                  fontSize: '1.125rem',
                  fontWeight: '600',
                  color: '#1f2937'
                }}>
                  English Description
                </label>
              </div>
              <div style={{ position: 'relative' }}>
                <textarea
                  value={form.description.en}
                  onChange={(e) => setForm({ 
                    ...form, 
                    description: { ...form.description, en: e.target.value } 
                  })}
                  onKeyPress={handleKeyPress}
                  placeholder="Enter step description in English..."
                  autoFocus
                  style={{
                    width: '100%',
                    height: '120px',
                    padding: '1rem',
                    border: '2px solid #e2e8f0',
                    borderRadius: '12px',
                    fontSize: '1rem',
                    lineHeight: '1.5',
                    background: '#ffffff',
                    resize: 'vertical',
                    transition: 'all 0.2s ease',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                  onFocus={e => {
                    e.target.style.borderColor = '#a855f7';
                    e.target.style.boxShadow = '0 0 0 3px rgba(168, 85, 247, 0.1)';
                  }}
                  onBlur={e => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: '0.75rem',
                  right: '0.75rem',
                  background: 'rgba(15, 23, 42, 0.8)',
                  color: 'white',
                  padding: '0.25rem 0.5rem',
                  borderRadius: '6px',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>
                  {form.description.en.length} chars
                </div>
              </div>
            </div>
            <div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '1rem'
              }}>
                <div style={{
                  width: '28px',
                  height: '20px',
                  background: 'linear-gradient(to right, #002654 33%, #fff 33%, #fff 66%, #ed2939 66%)',
                  borderRadius: '4px',
                  marginRight: '0.75rem',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}></div>
                <label style={{
                  fontSize: '1.125rem',
                  fontWeight: '600',
                  color: '#1f2937'
                }}>
                  French Description
                </label>
              </div>
              <div style={{ position: 'relative' }}>
                <textarea
                  value={form.description.fr}
                  onChange={(e) => setForm({ 
                    ...form, 
                    description: { ...form.description, fr: e.target.value } 
                  })}
                  onKeyPress={handleKeyPress}
                  placeholder="Entrez la description de l'étape en français..."
                  style={{
                    width: '100%',
                    height: '120px',
                    padding: '1rem',
                    border: '2px solid #e2e8f0',
                    borderRadius: '12px',
                    fontSize: '1rem',
                    lineHeight: '1.5',
                    background: '#ffffff',
                    resize: 'vertical',
                    transition: 'all 0.2s ease',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                  onFocus={e => {
                    e.target.style.borderColor = '#a855f7';
                    e.target.style.boxShadow = '0 0 0 3px rgba(168, 85, 247, 0.1)';
                  }}
                  onBlur={e => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: '0.75rem',
                  right: '0.75rem',
                  background: 'rgba(15, 23, 42, 0.8)',
                  color: 'white',
                  padding: '0.25rem 0.5rem',
                  borderRadius: '6px',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>
                  {form.description.fr.length} chars
                </div>
              </div>
            </div>
          </div>
          {getConnectionsCount() > 0 && (
            <div style={{
              marginTop: '2rem',
              background: 'linear-gradient(135deg, rgba(168, 85, 247, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%)',
              border: '1px solid rgba(168, 85, 247, 0.1)',
              borderRadius: '12px',
              padding: '1.5rem'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '1rem'
              }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #a855f7 0%, #8b5cf6 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '0.75rem'
                }}>
                  <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>→</span>
                </div>
                <h3 style={{
                  fontSize: '1.125rem',
                  fontWeight: '600',
                  color: '#1f2937',
                  margin: 0
                }}>
                  Current Connections
                </h3>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
                {Object.entries(form.options || {}).map(([label, target]) => (
                  <div
                    key={`${label}-${target}`}
                    style={{
                      background: '#ffffff',
                      border: '1px solid #e2e8f0',
                      borderRadius: '8px',
                      padding: '0.5rem 0.75rem',
                      display: 'flex',
                      alignItems: 'center',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                    }}
                  >
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      background: '#a855f7',
                      marginRight: '0.5rem'
                    }}></div>
                    <span style={{
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      color: '#374151'
                    }}>
                      {label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div style={{
            marginTop: '1.5rem',
            padding: '1rem',
            background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
            border: '1px solid #bae6fd',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center'
          }}>
            <div style={{
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              background: '#3b82f6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '0.75rem',
              flexShrink: 0
            }}>
              <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>i</span>
            </div>
            <span style={{ color: '#0369a1', fontSize: '0.875rem' }}>
              Press <strong>Ctrl+Enter</strong> to save quickly. Both descriptions are required to update the step.
            </span>
          </div>
        </div>

        {/* Footer Section */}
        <div style={{
          padding: '1.5rem 2.5rem 2rem',
          background: '#ffffff',
          borderTop: '1px solid #e2e8f0',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '1rem'
        }}>
          <button
            type="button"
            onClick={handleButtonClick(onClose)}
            style={{
              padding: '0.75rem 1.5rem',
              background: '#ffffff',
              border: '2px solid #d1d5db',
              borderRadius: '10px',
              color: '#374151',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={e => {
              e.target.style.background = '#f9fafb';
              e.target.style.borderColor = '#9ca3af';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={e => {
              e.target.style.background = '#ffffff';
              e.target.style.borderColor = '#d1d5db';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleButtonClick(handleSave)}
            disabled={!form.description.en.trim() || !form.description.fr.trim()}
            style={{
              padding: '0.75rem 2rem',
              background: (form.description.en.trim() && form.description.fr.trim()) 
                ? 'linear-gradient(135deg, #a855f7 0%, #8b5cf6 100%)' 
                : '#e5e7eb',
              border: 'none',
              borderRadius: '10px',
              color: (form.description.en.trim() && form.description.fr.trim()) ? '#ffffff' : '#9ca3af',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: (form.description.en.trim() && form.description.fr.trim()) ? 'pointer' : 'not-allowed',
              transition: 'all 0.2s ease',
              boxShadow: (form.description.en.trim() && form.description.fr.trim()) 
                ? '0 4px 14px 0 rgba(168, 85, 247, 0.25)' 
                : 'none'
            }}
            onMouseEnter={e => {
              if (form.description.en.trim() && form.description.fr.trim()) {
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 6px 20px 0 rgba(168, 85, 247, 0.35)';
              }
            }}
            onMouseLeave={e => {
              if (form.description.en.trim() && form.description.fr.trim()) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 14px 0 rgba(168, 85, 247, 0.25)';
              }
            }}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}